import { FilterTypeEnum, IFilter } from 'src/components/price-list/types';
import { AlternativePrice, Price } from 'src/types';

export const getApplicableFilters = (
  filters: IFilter[],
  offers: Price[],
  allOffersWithActiveAdditives: Price[]
): IFilter[] => {
  const hasAuthorizedInOffers = getHasAuthorizedInOffers(
    allOffersWithActiveAdditives
  );
  const hasPickupOffers = getHasPickupOffers(offers);
  const hasInternationalOffers = getHasInternationalOffers(offers);
  const hasNotAvailibleOffers = getHasNotAvailibleOffers(offers);
  const updatedFilters = filters.filter(
    filter =>
      (filter.type !== FilterTypeEnum.AUTHORIZED_DEALER ||
        hasAuthorizedInOffers) &&
      (filter.type !== FilterTypeEnum.PICKUP_ONLY || hasPickupOffers) &&
      (filter.type !== FilterTypeEnum.INTERNATIONAL ||
        hasInternationalOffers) &&
      (filter.type !== FilterTypeEnum.NOT_FOR_SALE || hasNotAvailibleOffers)
  );
  return updatedFilters;
};

const getHasAuthorizedInOffers = (offers: Price[]): boolean =>
  offers.some(offer => offer.authorizedDealer);

const getHasPickupOffers = (offers: Price[]): boolean => {
  return offers.some(
    offer => offer.type === 'pickup_only' || getHasPickupAlternatives(offer)
  );
};

const getHasPickupAlternatives = (offer: Price): boolean => {
  const alternativeOffers = (offer.alternativePrices ??
    []) as AlternativePrice[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(altOffer => altOffer.type === 'pickup_only');
};

const getHasInternationalOffers = (offers: Price[]): boolean => {
  return offers.some(
    offer => !offer.primaryMarket || getHasInternationalAlternatives(offer)
  );
};

const getHasInternationalAlternatives = (offer: Price): boolean => {
  const alternativeOffers = (offer.alternativePrices ??
    []) as AlternativePrice[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(altOffer => !altOffer.primaryMarket);
};

const getHasNotAvailibleOffers = (offers: Price[]): boolean => {
  return offers.some(
    offer =>
      offer.type === 'not_available_for_purchase' ||
      getHasNotAvailibleAlternatives(offer)
  );
};

const getHasNotAvailibleAlternatives = (offer: Price): boolean => {
  const alternativeOffers = (offer.alternativePrices ??
    []) as AlternativePrice[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(
    altOffer => altOffer.type === 'not_available_for_purchase'
  );
};
